import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro'

import SEO from 'components/SEO/SEO';
import { useDavidApi } from 'utility/DavidApi/DavidApi';
import Container from 'components/Grid/Container';
import AddForemanForm from "components/Form/AddForemanForm";
import Button from 'components/Button/Button';
import Modal from 'components/Modal/Modal';
import useModal from 'components/Modal/useModal';
import DataTable from 'components/Table/DataTable';
import TableModal from 'components/Table/TableModal';
import DeleteForemanForm from 'components/Form/DeleteForemanForm';
import EditForemanForm from 'components/Form/EditForemanForm';
import Row from 'components/Grid/Row';

import { YellowButtonWrapper } from 'components/Button/Button.styles';
import prettyPhone from 'utility/prettyPhone';

const columns = [
    {
        name: "name",
        label: "Name",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "client",
        label: "Client",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "email",
        label: "Email",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "phone",
        label: "Phone",
        options: {
            filter: true,
            sort: true,
        }
    },
    {
        name: "actions",
        label: "Actions",
        options: {
            filter: false,
            sort: false,
        }
    },
];

function Foremen() {
    const api = useDavidApi();
    const [loading, setLoading] = useState(true);
    const [clients, setClients] = useState([]);
    const newForemanModal = useModal();
    const deleteForemanModal = useModal();
    const editForemanModal = useModal();
    const [deleteForemanModalForeman, setDeleteForemanModalForeman] = useState(null);
    const [editForemanModalForeman, setEditForemanModalForeman] = useState(null);

    useEffect(() => {
        setLoading(true);
        (async () => {
            await api.getForemen();
            const fetchedClients = await api.getClients();
            setClients(fetchedClients || []);
        })();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (api.foremen === null) {
            return;
        }

        setLoading(false);

    }, [api.foremen]);

    const deleteForemanModalTriggerHandler = (foreman) => {
        setDeleteForemanModalForeman(foreman);
        deleteForemanModal.show();
    }

    const editForemanModalTriggerHandler = (foreman) => {
        setEditForemanModalForeman(foreman);
        editForemanModal.show();
    }

    const getClientName = (client) => {
        if (!client) return '';
        if (typeof client === 'object') return client.name ?? '';
        return client; // already a string
    }

    const getTableRowDataForForeman = (foreman) => {
        let foremanTableRowData = {
            ...foreman,
            ...{
                client: getClientName(foreman.client),
                phone: prettyPhone(foreman.phone),
                actions: (
                    <div className="table-row-actions-container">
                        <Button
                            size={'sm'}
                            iconLeft={<FontAwesomeIcon icon={solid('edit')} />}
                            onClick={() => editForemanModalTriggerHandler(foreman)}
                        >
                            Edit
                        </Button>
                        <Button
                            size={'sm'}
                            iconLeft={<FontAwesomeIcon icon={solid('trash')} />}
                            onClick={() => deleteForemanModalTriggerHandler(foreman)}
                            variant="red"
                        >
                            Delete
                        </Button>
                    </div>
                )
            }
        };

        return foremanTableRowData;
    }

    return (
        <>
            <SEO title="Foremen" />
            <Container vpadding={30}>
                <h1>Manage Foremen</h1>
                <Modal isShowing={newForemanModal.isShowing} hide={newForemanModal.hide} title="Add New Foreman">
                    <AddForemanForm
                        hideModal={newForemanModal.hide}
                    />
                </Modal>
                <div>
                    <DataTable
                        columns={columns}
                        data={Array.isArray(api.foremen) ? api.foremen.map(getTableRowDataForForeman) : []}
                        loading={loading}
                        options={{
                            sortOrder: {
                                name: 'name',
                                direction: 'asc',
                            }
                        }}
                    />
                    <Modal title="Edit Foreman" isShowing={editForemanModal.isShowing} hide={editForemanModal.hide}>
                        <EditForemanForm
                            foreman={editForemanModalForeman}
                            hideModal={editForemanModal.hide}
                        />
                    </Modal>
                    <TableModal title="Delete Foreman" isShowing={deleteForemanModal.isShowing} hide={deleteForemanModal.hide}>
                        <DeleteForemanForm
                            foreman={deleteForemanModalForeman}
                            hideModal={deleteForemanModal.hide}
                        />
                    </TableModal>
                </div>
                <Row>
                    <YellowButtonWrapper>
                        <Button
                            onClick={newForemanModal.show}
                            iconLeft={<FontAwesomeIcon icon={solid('plus')} />}
                        >
                                Add Foreman
                        </Button>
                    </YellowButtonWrapper>
                </Row>
            </Container>
        </>
    )
}

export default Foremen;
